import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from "gsap/SplitText.js";

function dm_reveal() {
    /*let noRevealParam = getParameterByName('noReveal');
    if (noRevealParam !== null) {
        return false;
    }*/

    if (window.location.hash) return; // cancel reveal if we have a # in the url

    gsap.registerPlugin(ScrollTrigger);

    reset_scroll_triggers();

    function animateFrom(elem, direction, scale) {
        if ( elem.classList.contains('no-scroll-reveal') ) return;

        direction = direction || 1;
        let x = 0,
            y = scale ? direction * 25 : 0;

        elem.style.transform = "translate(" + x + "px, " + y + "px) ";
        elem.style.opacity = "20";

        if ( scale ){
            elem.style.transform = "scale(0.9)";
        }

        gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0, transform: scale ? "scale(0.9)" : "scale(1)"}, {
            duration: 1.3,
            x: 0,
            y: 0,
            autoAlpha: 1,
            transform: "scale(1)",
            ease: "expo",
            overwrite: "auto"
        });

        elem.classList.remove("reveal");
        elem.classList.add("no-scroll-reveal");
    }

    // Element reveal
    gsap.utils.toArray($('section').find("h1,h2,h3,h4,h5,h6,p,span,li,pre,a,button,img,video, span i,.reveal")).forEach(function(elem, i) {
        if  ( $(elem).closest('.no-scroll-reveal').length > 0 || $(elem).closest('div').hasClass('slick-slider') ) return;

        // hide(elem); // assure that the element is hidden when scrolled into view

        let scale = false;
        if ( $(elem).get(0).tagName == 'IMG' || $(elem).get(0).tagName == 'VIDEO' || $(elem).get(0).tagName == 'SVG' ){
            scale = true;
        }

        ScrollTrigger.create({
            trigger: elem,
            onEnter: function() { animateFrom(elem, 1, scale) },
            // onEnterBack: function() { animateFrom(elem, -1, spin) },
            // onLeave: function() { hide(elem) }, // assure that the element is hidden when scrolled into view
            overwrite: "all"
        });
    });

    // Existing scroll animations
    gsap.utils.toArray($('section')).forEach(function(elem, i) {
        if  ( $(elem).hasClass('on-stage') ) return;

        ScrollTrigger.create({
            trigger: elem,
            start: "top center", 
            onEnter: function() { elem.classList.add("on-stage"); },
            overwrite: "all"
        });
    });

    function reset_scroll_triggers(){
        $(window).trigger('resize');
        ScrollTrigger.killAll();
        ScrollTrigger.refresh();
    }

};

export { dm_reveal };